import Tree from 'rc-tree'
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import LightTooltip from '../../../../commonComponents/LightTooltip'
import { Box, Button, Checkbox, Divider, FormControl, FormControlLabel, FormLabel, InputLabel, Menu, MenuItem, OutlinedInput, Radio, RadioGroup, Select, Stack, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import { customDecoding, deepSetValueLogWFItemDetails, filterNodes, filterOutNodeTypes, isParentKeyValueTrueNested, isUniqueItemName, scrollToSelectedItem, validateWorkflowItemName } from '../../../../utils/utilFunctions'
import { cloneDeep, debounce, set } from "lodash"
import { eachDeep } from "deepdash-es/standalone"
import SourceType from '../../../TemplateProperties/SourceType'
import { MoreHorizOutlined } from "@mui/icons-material"
import RegularExpressionDialog from "../../Forms/RegularExpressionDialog"
import { operatorsDropdowns, SystemDataListArray, TRANSLATE_OUTBOUND_CONDITION_MAPPING_2, TRANSLATE_OUTBOUND_CONDITION_MAPPING_2_SOURCE, workflowOperatorsDropDown } from '../../../../constants/constantList'
import { useDispatch, useSelector } from 'react-redux'
import { lgDocPath } from '../../../../constants/languageDocPaths'
import { api } from '../../../../redux/api'
import { inboundTemplateToRcTree } from '../../../../utils/rctreeDataConversion'
import WorkflowSourceType from '../../../../commonComponents/WorkflowSourceTypeComponent/WorkflowSourceType'
import LabeledCheckbox from '../../../TemplateProperties/TPCheckbox'
import { ParentScreenCtx } from '../../../../pages/workbench_build/WorkbenchBuild'
import { treeActions } from '../../../../redux/slices/treeSlice'
import { PatternControl } from '../../Forms/PatternControl'
import { use } from 'react'
import ErrorModal from '../../Forms/FieldDataValidation/ErrorModal'

const ConditionalIF = ({ node, source }) => {
    const { t } = useTranslation()
    const [selectedKey, setSelectedKey] = React.useState([])
    const [expandedKeys, setExpandedKeys] = React.useState([])
    const [anchorEl, setAnchorEl] = React.useState(null)
    const conditionRef = React.useRef(null)
    const [treeData, setTreeData] = React.useState([])
    const [name, setName] = useState("")
    const [ibTree, setIbTree] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [open, setOpen] = React.useState(false)
    const [doNotLog, setDoNotLog] = React.useState(false)
    const [disableWFItem, setDisableWFItem] = React.useState(false)
    const [concurrent, setConcurrent] = React.useState(false)
    const [selectedNode, setSelectedNode] = React.useState({})
    const [openRegExDialog, setOpenRegExDialog] = useState(false);
    const { account, baseUrl, lang } = useSelector(state => state.queryParams);
    const [accountKeys, setAccountKeys] = useState([]);
    const [tradingpartnerKeys, setTradingPartnerKeys] = useState([]);
    const dispatch = useDispatch();
    const parentScreen = useContext(ParentScreenCtx);
    const manualAction = useRef(false);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
    const translatedDataRef = useRef({});
    const rightSelectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
    const regExDocPath = `${baseUrl}/docs/${lgDocPath[lang] || 'en'}/Workbench/dialogs/regex.html`;
    const [parentLogWFItemChecked, setParentLogWFItemChecked] = useState(false);
    const errorHandlers = useSelector(state => state?.treeData?.[parentScreen]?.rightTree?.tree?.templateHeader?.WORKFLOW?.ERROR_HANDLER_LIST || []);
    const [conditionDisabled, setConditionDisabled] = useState(true);
    // Name validation states for workflow items only
    const [nameErrorModal, setNameErrorModal] = useState(false);
    const [nameErrorMessage, setNameErrorMessage] = useState('');
    const operatorDropdown = workflowOperatorsDropDown.map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
    })

    const booleanOperationDropdown = [{value: "TRUE" , text: t("TRUE")}, {value: "FALSE", text: t("FALSE")}].map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
    })

    const mapping2RecordDropdown = TRANSLATE_OUTBOUND_CONDITION_MAPPING_2.map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.title}</MenuItem>)
    })

    const systemDataDropdown = Object.keys(SystemDataListArray).map((operator, index) => {
        return (<MenuItem key={index} value={operator}>{t(operator)}</MenuItem>)
    });

    const handleMenuClick = (event) => {
        if (conditionDisabled) return;
        setAnchorEl(event.currentTarget)
    }

    const saveToRedux = (key, value, bulk) => {
        manualAction.current = true;
        const clonedData = cloneDeep(translatedDataRef.current);
        const elseKey = 
        rightSelectedNode?.key.split("-")
        .map((v, index, arr) => arr.length - 1 === index ? String(Number(v) + 1) : v)
        .join("-");

        

        eachDeep(clonedData, (obj) => {
            if(key === "NAME" && obj?.key === elseKey && obj?.hasOwnProperty("ELSE_NAME")) {
                obj["NAME"] = value || "UNNAMED";
            }

            if (obj?.key === rightSelectedNode?.key) {
                if (key === "LOG_WFITEM_DETAILS") {
                    obj[key] = value === "TRUE" ? "TRUE" : "FALSE";
                    obj["children"] = deepSetValueLogWFItemDetails(obj?.children, value);
                }
                else if (key) {
                    if (key === "NAME") {
                        obj[key] = value || "UNNAMED";
                        obj["title"] = value || "UNNAMED";
                    } else if (key === "WF_SESSION_NAME" || key === "FORMAT_WFSESSION_VAR") {
                       
                    } else obj[key] = value;
                } else {
                    Object.keys(bulk).forEach((e) => {
                        obj[e] = bulk[e];
                    });
                }
                dispatch(
                    treeActions.setRightTreeSelectedNode({
                        screen: parentScreen,
                        type: rightTree.currentTab,
                        data: obj,
                    })
                );
            }
        });
        dispatch(
            treeActions.setRightTreeTransData({
                screen: parentScreen,
                type: rightTree.currentTab,
                data: clonedData,
            })
        );
    }

    useEffect(() => {
        translatedDataRef.current = translatedData;
    }, [translatedData]);

    const submitHandler = useCallback((data) => {
        const getCleanedData = (data, operator) => {
            return data?.map(e => {
                const newObj = {
                    ...e,
                    ...((!e?.hasOwnProperty("CHILDOPERATOR") && operator) ? { OPERATOR: operator } : {}),
                    ...(e?.children?.length ? { CONDITION: getCleanedData(e?.CONDITION, e?.CHILDOPERATOR) } : {})
                }
                const keysRemoved = ["key", "title", "children"];

                keysRemoved.forEach(e => {
                    if (newObj?.hasOwnProperty(e) || newObj[e] ===  null) delete newObj?.[e];
                })

                Object.keys(newObj).forEach((key) => {
                    if (newObj[key] === undefined || newObj[key] === null || key.toLowerCase() === key) delete newObj[key];
                });
                
                return newObj;
            })
        }
        const cleanedData = getCleanedData(data);
        saveToRedux("CONDITION", cleanedData);
        setOpen(false)
    }, [])

    useEffect(() => {
        if (source === "errorHandler" && !manualAction.current) setTimeout(() => {
            dataToRCTree(rightSelectedNode?.CONDITION || [], true)
        });
        manualAction.current = false;
    }, [rightSelectedNode?.CONDITION, source])

    useEffect(() => {
        setDoNotLog(rightSelectedNode?.LOG_WFITEM_DETAILS  === "FALSE")
        setConcurrent(rightSelectedNode?.CONCURRENT === "TRUE")
        setDisableWFItem(rightSelectedNode?.ENABLED === "FALSE")
        setName(rightSelectedNode?.NAME || "UNNAMED")
        dataToRCTree(rightSelectedNode?.CONDITION || [], true)
        const isLogWFItemDetailsFalse = isParentKeyValueTrueNested("LOG_WFITEM_DETAILS", "FALSE",translatedData, rightSelectedNode);
        setParentLogWFItemChecked(isLogWFItemDetailsFalse);
    }, [rightSelectedNode?.key])


    const handleMenuClose = (source) => {
        setAnchorEl(null);
        manualAction.current = true;
        if (source) {
            const data = JSON.parse(JSON.stringify(treeData));
            const newNode =
                source === "CONDITION" ? conditionNode : compoundConditionNode;
            if (!selectedKey?.length) {
                data.push(newNode);
                setSelectedKey(["cf-0"]);
                setSelectedNode({ key: "cf-0", ...newNode });
                if (source === "COMPOUND_CONDITION") setExpandedKeys(["cf-0"]);
            } else {
                const keyArray = selectedKey?.[0]?.split("-") || [];
                const [pre, ...rest] = keyArray;
                let tempData = data;
                for (let i = 0; i < rest.length; i++) {
                    const index = Number(rest[i]);
                    if (i === rest.length - 1) {
                        if (tempData?.[index]?.CHILDOPERATOR && source === "CONDITION") {
                            tempData = tempData?.[index]?.CONDITION;
                            tempData.push(newNode);
                            const key = selectedKey[0] + "-" + `${tempData?.length - 1}`;
                            setSelectedKey([key]);
                            setSelectedNode({ key, ...newNode });
                            setExpandedKeys((prev) => [...prev, selectedKey[0]]);
                        } else {
                            tempData.push(newNode);
                            keyArray.pop();
                            keyArray.push(tempData.length - 1);
                            setSelectedKey([keyArray?.join("-")]);
                            setSelectedNode({ key: keyArray?.join("-"), ...newNode });
                            if (source === "COMPOUND_CONDITION")
                                setExpandedKeys((prev) => [...prev, keyArray?.join("-")]);
                        }
                    } else {
                        tempData = tempData?.[index]?.CONDITION;
                    }
                }
            }
            submitHandler(data);
            dataToRCTree(data);
        }
    };

    const dataToRCTree = (data, initialRender) => {
        const clonedData = JSON.parse(JSON.stringify(data));
        const loopData = (data, parentKey) => {
            return data?.map((e, i) => {
                if (e.CONDITION) {
                    e.ICON_DISPLAY = "COMPOUND_CONDITION";
                } else {
                    e.ICON_DISPLAY = "MAPPING_CONDITION";
                }
                e["key"] = parentKey + "-" + i;
                if (e?.CONDITION && e?.CHILDOPERATOR)
                    e.title = e?.NAME + ` (${e.CHILDOPERATOR})`;
                else e.title = e?.NAME;
                if (e?.CONDITION?.length)
                    e.children = loopData(e?.CONDITION, parentKey + "-" + i);
                else e.children = [];
                return e;
            });
        };

        const newData = loopData(clonedData, "cf");
        if(initialRender) {
            setSelectedKey(["cf-0"]);
            setSelectedNode(newData?.[0] || {});
        }
        setTreeData(newData);
    };

    const conditionsUpdater = (key, value, valuesObj) => {
        manualAction.current = true;
        const rcTreeData = cloneDeep(treeData);
        eachDeep(rcTreeData, (obj) => {
            if (obj?.key && obj?.key === selectedNode?.key) {
                if (!key) {
                    Object.keys(valuesObj).forEach((e) => {
                        obj[e] = valuesObj[e];
                    });
                } else obj[key] = value;
                setSelectedNode(obj);
            }
        });
        submitHandler(rcTreeData);
        dataToRCTree(rcTreeData);
    };

    const conditionDeleteHandler = () => {
        if (conditionDisabled) return;
        manualAction.current = true;
        const data = JSON.parse(JSON.stringify(treeData));
        const keyArray = selectedKey?.[0]?.split("-") || [];
        const [pre, ...rest] = keyArray;
        let tempData = data;
        let parentNode = {};
        for (let i = 0; i < rest.length; i++) {
            const index = Number(rest[i]);
            if (i === rest.length - 1) {
                let key = selectedKey?.[0]?.split("-");
                if (index === 0) {
                    if (key?.length === 2 && tempData?.length === 1) {
                        setSelectedKey([]);
                        setSelectedNode({});
                    }
                    if (key?.length === 2 && tempData?.length > 1) {
                        setSelectedKey(["cf-0"]);
                        setSelectedNode(tempData?.[1] || {});
                    } else {
                        if (key.length > 2) {
                            key.pop();
                            setSelectedKey([key.join("-")]);
                            setSelectedNode(parentNode);
                        } else {
                            setSelectedKey([]);
                            setSelectedNode({});
                        }
                    }
                } else {
                    key?.pop();
                    key?.push(index - 1);
                    setSelectedKey([key?.join("-")]);
                    setSelectedNode(tempData?.[index - 1] || {});
                }
                tempData.splice(index, 1);
            } else {
                parentNode = tempData?.[index];
                tempData = tempData?.[index]?.CONDITION;
            }
        }
        submitHandler(data);
        dataToRCTree(data);
    };

    // const conditionCopyHandler = () => {
    //     console.log("Copy")
    // }

    const handleNameBlur = (eVal) => {
        if (source === "errorHandler") {
            let newName = eVal;
            if (eVal === '' || eVal === undefined || eVal === null) {
              newName = rightSelectedNode?.NAME;
              setName(newName);
              setTimeout(() => {
                dispatch(treeActions.setIsInputFocusedFalse());
              }, 100);
              return;
            }
        
            const isUniqueWorkflowName = isUniqueItemName(newName, rightTree.tree.body.translatedData, rightSelectedNode?.key);
            if (!isUniqueWorkflowName) {
              setName(rightSelectedNode?.NAME);
              setNameErrorMessage(t("BOX_WFITEM_NAMES_MUST_BE_UNIQUE"));
              setNameErrorModal(true);
              setTimeout(() => {
                dispatch(treeActions.setIsInputFocusedFalse());
              }, 100);
              return;
            }else {
              // Mark template as changed immediately to ensure flag is set before tab switch
              dispatch(treeActions.setTemplateChanged({ screen: parentScreen, data: true }));
              saveToRedux('NAME', newName);
              setTimeout(() => {
                dispatch(treeActions.setIsInputFocusedFalse());
              }, 100);
            }
            return;
        }

        const oldName = rightSelectedNode?.NAME || '';
        
        const validationResult = validateWorkflowItemName(
          eVal, 
          oldName, 
          translatedData, 
          rightSelectedNode?.key, 
          'CONDITIONAL_IF'
        );
        
        if (validationResult.isValid) {
          const newName = eVal?.trim() || '';
          setName(newName);
          if (newName !== oldName) {
            // Mark template as changed immediately to ensure flag is set before tab switch
            dispatch(treeActions.setTemplateChanged({ screen: parentScreen, data: true }));
            saveToRedux('NAME', newName);
            // Wait for debounce delay + buffer before dispatching
            setTimeout(() => {
              dispatch(treeActions.setIsInputFocusedFalse());
            }, 200);
          } else {
            // If no change, dispatch immediately
            setTimeout(() => {
              dispatch(treeActions.setIsInputFocusedFalse());
            }, 100);
          }
        } else {
          if (validationResult.errorMessage) {
            setNameErrorMessage(t(validationResult.errorMessage));
            setNameErrorModal(true);
          } else if (validationResult.shouldRevert) {
            setName(oldName);
          }
          // For error cases, dispatch immediately
          setTimeout(() => {
            dispatch(treeActions.setIsInputFocusedFalse());
          }, 100);
        }
    }

    const titleRender = (node) => {
        return <span data-key={`${node?.key}`}>{node.title}</span>;
    }

    const Icon = (node) => {
        return (
            <span
                data-key={`${node?.key}`}
                className={"tree-icon " + node.ICON_DISPLAY}
            ></span>
        );
    };

    const debouncedConditionsUpdater = useCallback(debounce(conditionsUpdater, 400), [
        selectedNode,
        treeData,
        rightSelectedNode,
    ]);

    const switcherIcon = (obj) => {
        if (obj.isLeaf) return;
        if (obj.expanded) return <ArrowDropDownIcon />;
        else return <ArrowRightIcon sx={{ color: "#666666" }} />;
    };

    const selectHandler = (selectedKeys, info) => {
        setSelectedKey([info.node.key])
        setSelectedNode(info.node)
    }

    const expandHandler = (expandedKeys, { expanded, node }) => {
        setExpandedKeys(expandedKeys)
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target
        conditionsUpdater(name, type === "checkbox" ? checked ? "TRUE" : "FALSE" : value)
    }

    const handleNameErrorModal = (isOpen) => {
        setNameErrorModal(isOpen);
        if (!isOpen) {
          const oldName = rightSelectedNode?.NAME || '';
          setName(oldName);
        }
    }


    useEffect(() => {
        if (conditionRef?.current) {
            scrollToSelectedItem(selectedKey, conditionRef);
        }
    }, [selectedKey]);

    useEffect(() => {
        if (["ACCOUNT_KEYS", "TRADING_PARTNER_KEYS"].includes(selectedNode?.RECORD_TYPE2)) {
            const apiEndpoints = {
                'ACCOUNT_KEYS': api.endpoints.getAccountData,
                'TRADING_PARTNER_KEYS': api.endpoints.getTradingPartnersKeys
            }
            dispatch(apiEndpoints?.[selectedNode?.RECORD_TYPE2]?.initiate({
                account
            }, { forceRefetch: true }))
                .then(res => {
                    if (res.data.current_state === "SUCCESS") {
                        let data;

                        if (res?.data?.data?.account_data_keys) {
                            data = res?.data?.data?.account_data_keys.map(
                                (o) => Object?.keys(o)?.[0]
                            );
                        } else if (res?.data?.data?.trading_partner_keys) {
                            data = res?.data?.data?.trading_partner_keys;
                        }
                        if (data) {
                            const newData = [t("SELECT"), ...data];
                            const options = newData.map((opt, idx) => ({
                                key: `${opt}-${idx}`,
                                value: opt,
                                label: opt
                            }))
                            if (selectedNode?.RECORD_TYPE2 === "ACCOUNT_KEYS") setAccountKeys(options?.map(e => {
                                return <MenuItem value={e?.value}>{e?.value}</MenuItem>
                            }));
                            if (selectedNode?.RECORD_TYPE2 === "TRADING_PARTNER_KEYS") setTradingPartnerKeys(options?.map(e => {
                                return <MenuItem value={e?.value}>{e?.value}</MenuItem>
                            }));
                        }
                    }
                })
        }
    }, [selectedNode?.RECORD_TYPE2])

    useEffect(() => {
        // Set initial state based on selected node properties
        if(source === "errorHandler" && rightSelectedNode.NAME && rightSelectedNode.NAME !== name) setName(rightSelectedNode?.NAME || "");
    }, [rightSelectedNode?.NAME])

    useEffect(() => {
        if (source !== "errorHandler") {
            setConditionDisabled(false);
            return;
        }
        if (source === "errorHandler") {
            const errorHandlerOptions = [{OUTBOUND_NAME: t("SELECT")}, ...(errorHandlers || [])].map((item) => (
                <MenuItem key={item} data-Id={item?.ID} value={item?.OUTBOUND_NAME}>
                  {item?.OUTBOUND_NAME}
                </MenuItem>
              ));
            setConditionDisabled(!rightSelectedNode?.OUTBOUND_NAME || rightSelectedNode?.OUTBOUND_NAME === t("SELECT") || errorHandlerOptions?.filter(e => e.props["data-Id"] == rightSelectedNode?.OUTBOUND_ID)?.length === 0);
        }
    }, [rightSelectedNode?.OUTBOUND_NAME, rightSelectedNode?.OUTBOUND_ID]) // Removed errorHandlers because it is rerendering multiple times.



    return (
        <>
        <FormControl variant='outlined' className='width-100' size='small' sx={{ marginBottom: 2 }}>
            <InputLabel
            htmlFor='error-handler-name-input'
            sx={{ padding: "0 6px !important", left: "-5px" }}
            >
            {t('COL_NAME')}
            </InputLabel>
            <OutlinedInput
            id="error-handler-name-input"
            size='small'
            variant='outlined'
            fullWidth
            autoComplete='off' 
            value={name || ""} 
            endAdornment={<div style={styles.nameAdornment}>{`ID: ${rightSelectedNode?.ID || ""}`}</div>}
            onBlur={(e) => handleNameBlur(e?.target?.value)}
            onFocus={() => dispatch(treeActions.setIsInputFocusedTrue())}
            onChange={(e) => {
                if (source === "errorHandler") {
                    setName(e.target.value);
                } else {
                    setName(e.target.value);
                }
            }} />
            </FormControl>
            {source !== "errorHandler" && <Box
                variant='outlined'
                sx={{ display: "flex", flexWrap: "wrap", my: 1 }}
                className='width-100'
                size='small'
            >
                <LabeledCheckbox
                    label={t("LBL_LOG_NO_WFITEM_DETAILS")}
                    handleCheck={(checked) => {
                        setDoNotLog(checked);
                        saveToRedux(
                            "LOG_WFITEM_DETAILS",
                            checked ? "FALSE" : "TRUE"
                        );
                    }}
                    checked={doNotLog}
                    disabled={parentLogWFItemChecked}
                />
                <LabeledCheckbox
                    label={t("LBL_RUN_CONCURRENTLY")}
                    handleCheck={(checked) => {
                        setConcurrent(checked);
                        saveToRedux(
                            "CONCURRENT",
                            checked ? "TRUE" : "FALSE"
                        );
                    }}
                    checked={concurrent}
                />
                <LabeledCheckbox
                    label={t("LBL_DISABLE_WFITEM")}
                    handleCheck={(checked) => {
                        setDisableWFItem(checked);
                        saveToRedux(
                            "ENABLED",
                            checked ? "FALSE" : "TRUE"
                        );
                    }}
                    checked={disableWFItem}
                />
            </Box>}
            {source !== "errorHandler" && <div style={styles.dialogHeader} className="dialog-header">
                {/* <InputLabel>{t("BTN_OUT_COND_PROPS")}: UNNAMED</InputLabel> */}
            </div>}
            <div>
                <div
                    style={{
                        marginBottom: "4px",
                        overflowX: "hidden",
                        position: "relative",
                    }}
                    ref={conditionRef}
                    className="div-textBox-conditional-field"
                >
                    <div
                        style={{
                            backgroundColor: "#F2F2F2",
                            position: "sticky",
                            top: "0",
                            zIndex: "1000",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "93%",
                                margin: "auto",
                                padding: "2px",
                            }}
                        >
                            <div
                                style={{
                                    color: "#666666",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                }}
                            >
                                {t("LBL_CONDITIONS")}
                            </div>
                            <div style={{ display: "flex", gap: "5px" }}>
                                <div>
                                    <LightTooltip arrow disabled={conditionDisabled} onClick={handleMenuClick}>
                                        <span
                                            style={{ cursor: "pointer" }}
                                            className="ADD_MUI"
                                        ></span>
                                    </LightTooltip>
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={() => handleMenuClose()}
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "left",
                                        }}
                                    >
                                        <MenuItem disabled={conditionDisabled} onClick={() => handleMenuClose("CONDITION")}>
                                            {t("MNU_NEW_COND")}
                                        </MenuItem>
                                        <MenuItem
                                            disabled={conditionDisabled}
                                            onClick={() => handleMenuClose("COMPOUND_CONDITION")}
                                        >
                                            {t("MNU_NEW_COMP_COND")}
                                        </MenuItem>
                                    </Menu>
                                </div>
                                <LightTooltip
                                    onClick={conditionDeleteHandler}
                                    title={t("DELETE")}
                                    disabled={conditionDisabled}
                                    arrow
                                >
                                    <span
                                        style={{ cursor: "pointer" }}
                                        className="DELETE_MUI"
                                    ></span>
                                </LightTooltip>
                                {/* <LightTooltip
                                            onClick={conditionCopyHandler}
                                            title={t("MNU_COPY")}
                                            arrow
                                        >
                                            <span
                                                style={{ cursor: "pointer" }}
                                                className="FILE_COPY"
                                            ></span>
                                        </LightTooltip> */}
                            </div>
                        </div>
                    </div>
                    <Tree
                        disabled={conditionDisabled}
                        titleRender={titleRender}
                        treeData={treeData}
                        icon={Icon}
                        selectedKeys={selectedKey}
                        switcherIcon={switcherIcon}
                        onSelect={selectHandler}
                        expandedKeys={expandedKeys}
                        onExpand={expandHandler}
                    />
                </div>
            </div>

            <Stack spacing={2} px={1} mt={2}>
                <TextField 
                    disabled={!selectedNode?.hasOwnProperty("key") || conditionDisabled} 
                    fullWidth size="small" label={t("LBL_CONDITION_NAME")} 
                    name="NAME" value={selectedNode.NAME || ""} 
                    onChange={(e) => {
                        const name = e?.target?.value ? e?.target?.value : "";
                        conditionsUpdater("NAME", name);
                    }} 
                    onBlur={(e) => {
                        const name = e?.target?.value ? e?.target?.value : "UNNAMED";
                        conditionsUpdater("NAME", name);
                    }}
                />
                {
                    selectedNode?.hasOwnProperty("CHILDOPERATOR") ?
                        <>
                            <InputLabel>{t("LBL_SEL_OPER_FOR_COND_CONTAINED_WITHIN_COMP_COND")}</InputLabel>
                            <FormControl
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                                ml={3}
                                disabled={!selectedNode?.hasOwnProperty("key") || conditionDisabled}
                            >
                                <FormLabel>{t("LBL_COMPOUND_OPER")}</FormLabel>
                                <RadioGroup
                                    row
                                    name="CHILDOPERATOR"
                                    value={selectedNode?.CHILDOPERATOR || "AND"}
                                    onChange={(e) => {
                                        conditionsUpdater("CHILDOPERATOR", e.target.value);
                                    }}
                                >
                                    <FormControlLabel
                                        value={"OR"}
                                        control={<Radio />}
                                        label={"OR"}
                                    />
                                    <FormControlLabel
                                        value={"AND"}
                                        control={<Radio />}
                                        label={"AND"}
                                    />
                                </RadioGroup>
                            </FormControl>
                        </> : <>
                            <InputLabel>{t("LBL_DATA_MAPPING_")} 1</InputLabel>
                            <WorkflowSourceType
                                disabled={!selectedNode?.hasOwnProperty("key") || conditionDisabled}
                                node={
                                    {
                                        key: selectedNode?.key,
                                        RECORD_TYPE: selectedNode?.RECORD_TYPE,
                                        WFITEM: selectedNode?.WF_ITEM_1,
                                        OUTBOUND_NAME: selectedNode?.OUTBOUND_1,
                                        MAPNAME: selectedNode?.MAPNAME,
                                        WF_ITEM_DEPENDENCY_TIMEOUT: selectedNode?.WF_ITEM_DEPENDENCY_TIMEOUT,
                                        WF_ITEM_ID: selectedNode?.WF_ITEM_ID_1,
                                        CALL_WORKFLOW: selectedNode?.CALL_WORKFLOW_ONE,
                                        CALL_WORKFLOW_ACCOUNT: selectedNode?.CALL_WORKFLOW_ACCOUNT_ONE,
                                        CALL_WORKFLOW_GROUP: selectedNode?.CALL_WORKFLOW_GROUP_ONE,
                                    }
                                }
                                valuesHandler={(values) => {
                                    conditionsUpdater(null, null, {
                                        RECORD_TYPE: values?.RECORD_TYPE,
                                        WF_ITEM_1: values?.WFITEM,
                                        OUTBOUND_1: values?.OUTBOUND_NAME,
                                        MAPNAME: values?.MAPNAME,
                                        WF_ITEM_ID_1: values?.WF_ITEM_ID,
                                        CALL_WORKFLOW_ACCOUNT_ONE: values?.CALL_WORKFLOW_ACCOUNT,
                                        CALL_WORKFLOW_ONE: values?.CALL_WORKFLOW,
                                        CALL_WORKFLOW_GROUP_ONE: values?.CALL_WORKFLOW_GROUP,
                                        WF_ITEM_DEPENDENCY_TIMEOUT: values?.WF_ITEM_DEPENDENCY_TIMEOUT,
                                        COMPARE: values?.COMPARE || selectedNode?.COMPARE,
                                    })
                                }}
                                compareValueApplicable={true}
                                enableWorkflowItemDependencyOption={true}
                                showTimeout={true}
                                hideSourceTypeOptions={source === "errorHandler" ? ["PLUGIN"] : ["PLUGIN", "PROCESSING_ERRORS", "STATUS_MESSAGES", "TRANSLATION_ERRORS"]}
                                source={"CONDITION_IF"}
                            />
                            <Divider />
                            {selectedNode?.RECORD_TYPE !== "WF_ITEM_DEPENDENCY" ? <><InputLabel>{t("LBL_OPERATOR")}</InputLabel>
                            <div style={{ display: "flex" }}>
                                 <FormControlLabel disabled={!selectedNode?.hasOwnProperty("key") || conditionDisabled} control={<Checkbox name="COMPARE_ACTION_NOT" checked={selectedNode.COMPARE_ACTION_NOT === "TRUE"} onChange={handleChange} />} label={t("BTN_NOT")} />
                                <FormControl disabled={!selectedNode?.hasOwnProperty("key") || conditionDisabled} fullWidth size="small">
                                    <InputLabel>{t("LBL_OPERATOR")}</InputLabel>
                                    <Select MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 200, // Adjust this value
                                            },
                                        },
                                    }} size="small" name="COMPARE" value={selectedNode?.COMPARE || "EQUALS"} onChange={handleChange}>
                                        {[
                                            "DATA_FOUND", 
                                            "COMMUNICATION_ERROR", 
                                            "TRANSLATION_ERRORS", 
                                            "PROCESSING_ERRORS", 
                                            "VALIDATION_ERRORS",
                                            "DATA_SENT",
                                            "ELEM_VAL_ERR",
                                            "TRN_SET_VAL_ERR",
                                            "FNCT_GRP_VAL_ERR",
                                            "SEG_VAL_ERR"
                                        ].includes(selectedNode?.MAPNAME) ? booleanOperationDropdown : operatorDropdown}
                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{ display: "flex" }}>
                                <FormControlLabel disabled={!selectedNode?.hasOwnProperty("key") || conditionDisabled} control={<Checkbox name="COMPARE_ACTION_IGNORECASE" checked={selectedNode.COMPARE_ACTION_IGNORECASE === "TRUE"} onChange={handleChange} />} label={t("IGNORECASE")} />
                                <FormControlLabel disabled={!selectedNode?.hasOwnProperty("key") || conditionDisabled} control={<Checkbox name="COMPARE_ACTION_TRIM" checked={selectedNode.COMPARE_ACTION_TRIM === "TRUE"} onChange={handleChange} />} label={t("LBL_TRIM_DATA")} />
                            </div>
                            {selectedNode?.COMPARE === "IS_DATE" ? <>
                                    <PatternControl
                                        inputId="fieldDecPattern"
                                        inputLabel={t("LBL_PATTERN")}
                                        pattern={selectedNode?.PATTERN}
                                        setPattern={(val) => {
                                            conditionsUpdater("PATTERN", val);
                                        }}
                                    />

                                </> : <></>}</> : <></>}
                            {   
                                (!["ISNULL", "IS_NUMERIC", "IS_DATE", "TRUE", "FALSE"].includes(selectedNode.COMPARE) && selectedNode?.RECORD_TYPE !== "WF_ITEM_DEPENDENCY") ? <>
                                    <Divider />
                                    <InputLabel>{t("LBL_DATA_MAPPING_")} 2</InputLabel>
                                    <WorkflowSourceType
                                        disabled={!selectedNode?.hasOwnProperty("key") || conditionDisabled}
                                        node={
                                            {
                                                key: selectedNode?.key,
                                                RECORD_TYPE: selectedNode?.RECORD_TYPE2,
                                                WFITEM: selectedNode?.WF_ITEM_2,
                                                OUTBOUND_NAME: selectedNode?.OUTBOUND_2,
                                                MAPNAME: selectedNode?.MAPNAME2,
                                                VALUE: selectedNode?.VALUE,
                                                INBOUND_PATTERN: selectedNode?.INBOUND_PATTERN_2,
                                                WF_ITEM_ID: selectedNode?.WF_ITEM_ID_2,
                                                CALL_WORKFLOW: selectedNode?.CALL_WORKFLOW_TWO,
                                                CALL_WORKFLOW_ACCOUNT: selectedNode?.CALL_WORKFLOW_ACCOUNT_TWO,
                                                CALL_WORKFLOW_GROUP: selectedNode?.CALL_WORKFLOW_GROUP_TWO,
                                            }
                                        }
                                        valuesHandler={(values) => {
                                            debouncedConditionsUpdater(null, null, {
                                                RECORD_TYPE2: values?.RECORD_TYPE,
                                                WF_ITEM_2: values?.WFITEM,
                                                OUTBOUND_2: values?.OUTBOUND_NAME,
                                                MAPNAME2: values?.MAPNAME,
                                                WF_ITEM_ID_2: values?.WF_ITEM_ID,
                                                CALL_WORKFLOW_ACCOUNT_TWO: values?.CALL_WORKFLOW_ACCOUNT,
                                                CALL_WORKFLOW_TWO: values?.CALL_WORKFLOW,
                                                CALL_WORKFLOW_GROUP_TWO: values?.CALL_WORKFLOW_GROUP,
                                                INBOUND_PATTERN_2: values?.INBOUND_PATTERN,
                                                VALUE: values?.VALUE,
                                            })
                                        }}
                                        source={"CONDITION_IF"}
                                        enableWorkflowItemDependencyOption={true}
                                        addConstantControl={true}
                                        enableTradingPartnerControl={true}
                                        hideSourceTypeOptions={source === "errorHandler" ? ["PLUGIN"] : ["PLUGIN", "PROCESSING_ERRORS", "STATUS_MESSAGES", "TRANSLATION_ERRORS"]}
                                    />
                                </> : <></>
                            }
                        </>

                }
            </Stack>

            {/* Error Modal for name validation */}
            <ErrorModal
                errorModal={nameErrorModal}
                setErrorModal={setNameErrorModal}
                errorMessage={nameErrorMessage}
                errorType={t('ERROR')}
                handleErrorModal={handleNameErrorModal}
            />

        </>
    )
}

// Keep the condition node constants
const conditionNode = {
    "NAME": "UNNAMED",
    "COMPARE": "EQUALS",
    "RECORD_TYPE" : "SESSION_DATA", 
    "RECORD_TYPE2" : "SESSION_DATA", 
    "WF_ITEM_DEPENDENCY_TIMEOUT" : "5000", 
    "PATTERN" : "MM/dd/yy", 
    "COMPARE_ACTION_TRIM" : "FALSE", 
    "COMPARE_ACTION_IGNORECASE" : "FALSE", 
    "COMPARE_ACTION_NOT" : "FALSE", 
    "BIT_MAP" : "" 

}

const compoundConditionNode = {
    "NAME": "COMPOUND CONDITION",
    "CHILDOPERATOR": "AND",
    "CONDITION": [
        {
            "NAME": "UNNAMED1",
            "OPERATOR": "AND",
            "COMPARE": "EQUALS",
            "RECORD_TYPE" : "SESSION_DATA", 
            "RECORD_TYPE2" : "SESSION_DATA", 
            "WF_ITEM_DEPENDENCY_TIMEOUT" : "5000", 
            "PATTERN" : "MM/dd/yy", 
            "COMPARE_ACTION_TRIM" : "FALSE", 
            "COMPARE_ACTION_IGNORECASE" : "FALSE", 
            "COMPARE_ACTION_NOT" : "FALSE", 
            "BIT_MAP" : "" 
        },
        {
            "NAME": "UNNAMED2",
            "OPERATOR": "AND",
            "COMPARE": "EQUALS",
            "RECORD_TYPE" : "SESSION_DATA", 
            "RECORD_TYPE2" : "SESSION_DATA", 
            "WF_ITEM_DEPENDENCY_TIMEOUT" : "5000", 
            "PATTERN" : "MM/dd/yy", 
            "COMPARE_ACTION_TRIM" : "FALSE", 
            "COMPARE_ACTION_IGNORECASE" : "FALSE", 
            "COMPARE_ACTION_NOT" : "FALSE", 
            "BIT_MAP" : "" 
        }
    ]
}

export default ConditionalIF

// Add some basic styles
const styles = {
    container: {
        padding: '16px',
        backgroundColor: '#fff',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
    },
    nameAdornment: {
    color: "#666666",
    fontSize: "9px",
    position: "absolute",
    right: "13px",
    top: "-6px",
    backgroundColor: "#FFF",
    zIndex: "2",
    padding: "0 5px",
    height: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}